import React, { useEffect, useState } from "react";
import ItemLists from "../ItemLists/ItemLists";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar/Sidebar";
import { getUserEmail } from "../../../utils/auth";
import BASE_URL from "../../../config/apiConfig";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./UserHome.scss";

function Home() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const email = getUserEmail();
        const response = await axios.post(
          `${BASE_URL}/api/payment/getTransactions`,
          { email }
        );

        if (response.data.transactions.length === 0) {
          setError(
            "You don't have any active subscriptions. Please check our plans."
          );
        } else {
          setTransactions(response.data.transactions);
        }
      } catch (err) {
        setError("Failed to fetch transactions. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return (
    <div className="home">
      <div className="home_items">
        <ItemLists type="farms" />
        <ItemLists type="plantation_crop_farms" />
        <ItemLists type="field_crop_farms" />
        {/* <ItemLists type="subscription" /> */}
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loader"></div>
        </div>
      ) : error ? (
        <div
          className="empty-message-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "60vh",
            textAlign: "center",
          }}
        >
          <p className="error-message">{error}</p>
          <div
            className="explore-plans-section"
            style={{
              marginTop: "20px",
              padding: "30px",
              borderRadius: "12px",
              backgroundColor: "#f3f4f6",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2
              className="explore-title"
              style={{
                marginBottom: "10px",
                fontSize: "24px",
                color: "#333",
              }}
            >
              Discover Our Plans
            </h2>
            <p
              className="explore-description"
              style={{
                marginBottom: "15px",
                fontSize: "16px",
                color: "#555",
              }}
            >
              Choose a plan that fits your needs and unlock premium features.
            </p>
            <button
              className="explore-plans-button"
              style={{
                backgroundColor: "#4CAF50",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                transition: "background 0.3s ease",
              }}
              onClick={() => navigate("/pricing")}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
            >
              Explore Plans
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Home;
